<template lang="pug">
  #container.wrap-content.container
    // start: CONTENT-TITLE
    section#page-title
        .row
            .col-sm-12
                h1.mainTitle  Регистрация 
                span.mainDescription  Расскажите пару слов о Вас и 
                    | будем приступать к <b>делу</b>
    // end: CONTENT-TITLE

    // start: CONTENT
    .container-fluid.container-fullw.bg-white
        .panel
            .panel-body
                .row
                    .col-md-2
                        #fix-height-div.form-group
                            v-select-styled(
                                v-model="profile.sex",
                                :searchable="false",
                                :clearable="false",
                                :options="sexChoice")

                    .col-md-5
                        .form-group(:class="{'has-error': !validation.first_name}")
                            .vfl-field.input-group(style='width: 100%;')
                                input(type="text", 
                                      required="",
                                      v-model="profile.first_name",
                                      @focus="validation.first_name = true")
                                span.field-underline
                                label Имя
                                    span(v-if='!validation.first_name', v-html="requiredNotice")

                    .col-md-5
                        .form-group(:class="{'has-error': !validation.last_name}")
                            .vfl-field.input-group(style='width: 100%;')
                                input(type="text", 
                                      required="",
                                      v-model="profile.last_name",
                                      @focus="validation.last_name = true")
                                span.field-underline
                                label Фамилия
                                    span(v-if='!validation.last_name', v-html="requiredNotice")
                .row
                    .col-md-2
                    .col-md-5
                        .form-group(:class="{'has-error': !passwordValid}")
                            .vfl-field.input-group(style='width: 100%;')
                                input(type="password", 
                                      required="",
                                      v-model="profile.password",
                                      @blur="passwordChanged = true",
                                      @focus="passwordChanged = false")
                                span.field-underline
                                label Пароль
                                    span(v-if="passwordChanged && tooShortPassword") <b> – минимум 6 символов </b>
                    .col-md-5
                        .form-group(:class="{'has-error': passwordCheckChanged && passwordsNotEqual}")
                            .vfl-field.input-group(style='width: 100%;')
                                input(type="password", 
                                      required="",
                                      v-model="passwordCheck",
                                      @blur="passwordCheckChanged = true")
                                span.field-underline
                                label Ещё разок пароль
                                    span(v-if='passwordCheckChanged && passwordsNotEqual') <b> – пароли не совпадают</b>
                .row
                    .col-md-2
                    .col-md-5
                        .form-group(:class="{'has-error': !validation.shop_domain}")
                            .vfl-field.input-group(style='width: 100%;')
                                input(type="text", 
                                      required="",
                                      v-model="profile.shop_domain",
                                      @focus="validation.shop_domain = true",
                                      @blur="onDomainBlur")
                                span.field-underline
                                label Ссылка на магазин 
                                    span(v-if='!validation.shop_domain', v-html="requiredNotice")
                    .col-md-5
                        field(
                            type="select",
                            label="CMS",
                            :item="cms",
                            search-path="/shops/cms/autocomplete/"
                        )
                .row
                    .col-md-2
                        .radio-inline(style="padding-left: 0!important;")
                            span(style="font-size: 13px; position: relative; margin-bottom: 6px; line-height: 23px;") Заказов:
                    .col-md-10
                        .form-group
                            .radio.clip-radio.radio-primary.radio-inline(v-for="item in sbTariffs")
                                input(:id="'sb-tariff-' + item.id", 
                                      type="radio", 
                                      v-model="profile.sb_tariff_id", 
                                      :value="item.id")
                                label(:for="'sb-tariff-' + item.id") 
                                    | {{ item.orders ? `до ${item.orders}` : `более 5000` }} в месяц
                .row
                    .col-md-2
                    .col-md-10
                        p(v-if="errorMessage", v-html="errorMessage") 

                .row
                    .col-md-3.col-xs-7
                        field(
                            label="Есть промокод? Докажите",
                            :item="promoCode"
                        )
                    .col-md-2.col-xs-5.margin-bottom-10
                        button.btn.btn-wide.btn-default(
                            :class="{disabled: !promoCode.value || applyPromoCodeButtonDisabled}",
                            @click="applyPromoCode"
                        ) Применить
                    .col-md-5(style="margin-top: 9px;") {{ applyPromoCodeMessage }}
                    .col-md-2
                        button.btn.btn-wide.btn-default.pull-right(
                            :class="{disabled: buttonDisabled}",
                            @click="go"
                        ) Приступим!

</template>

<script>
import vSelectStyled from '@/components/vSelectStyled';

import ajaxRequest from '@/utils/request';

export default {
    name: 'Registration',
    components: {vSelectStyled},
    created() {
        this.loadSbTariffs();
    },
    computed: {
        passwordsNotEqual() {
            return this.profile.password !== this.passwordCheck;
        },
        tooShortPassword() {
            return !this.profile.password || this.profile.password.length < 6;
        },
        passwordValid() {
            return !(
                (this.passwordChanged && this.tooShortPassword) ||
                (this.passwordChanged && this.passwordCheckChanged && this.passwordsNotEqual)
            );
        }
    },
    methods: {
        go() {
            console.log('go! go! go!');
            if (this.validate()) {
                this.buttonDisabled = true;
                this.$store.dispatch('registrate', {
                    ...this.profile,
                    sex: this.profile.sex.id,
                    cms_id: this.cms.value && this.cms.value.id
                })
                    .then(() => {
                        this.buttonDisabled = false;
                    })
                    .catch(errorMessage => {
                        this.errorMessage = errorMessage;
                        this.buttonDisabled = false;
                    });
            }
        },
        validate() {
            let requiredFields = Object.keys(this.validation);
            let valid = true;

            for (let field of requiredFields) {
                if (!this.profile[field]) {
                    this.validation[field] = false;
                    valid = false;
                }
            }

            this.passwordChanged = true;
            this.passwordCheckChanged = true;
            return valid && !this.passwordsNotEqual && !this.tooShortPassword;
        },
        loadSbTariffs() {
            ajaxRequest({
                url: '/payments/get_tariffs/',
                success: ({data}) => {
                    this.sbTariffs = data;
                    this.profile.sb_tariff_id = data[0].id;

                    this.$nextTick(initializeTheme);
                }
            });
        },
        onDomainBlur() {
            let domain = this.profile.shop_domain;
            if (domain && !domain.startsWith('http://') && !domain.startsWith('https://')) {
                this.profile.shop_domain = `http://${domain}`;
            }
        },
        applyPromoCode() {
            this.applyPromoCodeButtonDisabled = true;
            ajaxRequest({
                url: '/payments/apply_registration_promo_code/',
                method: 'POST',
                params: {
                    promo_code: this.promoCode.value
                },
                success: ({message}) => {
                    this.applyPromoCodeMessage = message;
                    this.promoCode.valid = true;

                    this.applyPromoCodeButtonDisabled = false;
                },
                failure: ({errorMessage}) => {
                    this.promoCode.message = errorMessage;
                    this.promoCode.valid = false;

                    this.applyPromoCodeButtonDisabled = false;
                }
            });
        }
    },
    data() {
        let sexChoice = [{name: 'Дорогой', id: 'м'}, {name: 'Дорогая', id: 'ж'}];

        return {
            requiredNotice: '<b> – обязательно для заполнения </b>',
            sexChoice,

            cms: {
                value: null,
                valid: true
            },
            promoCode: {
                value: null,
                valid: true
            },

            profile: {
                sex: sexChoice[0],
                first_name: null,
                last_name: null,
                password: null,
                shop_domain: null,
                sb_tariff_id: null
            },

            sbTariffs: [],

            passwordCheck: null,
            passwordChanged: false,
            passwordCheckChanged: false,

            validation: {
                first_name: true,
                last_name: true,
                shop_domain: true
            },

            buttonDisabled: false,
            applyPromoCodeButtonDisabled: false,

            applyPromoCodeMessage: null,
            errorMessage: null
        };
    }
};
</script>

<style>
span.cs-placeholder {
  height: 33px;
  padding: 8px 0 8px 0!important;
  display: block;
  width: 100%;
  border: none!important;
  border-bottom: var(--field-border)!important;
  border-radius: 0!important;
  background-color: #ffffff!important;
}
.panel {
    margin-bottom: 0;
}
#fix-height-div .dropdown-toggle {
    max-height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Registration.vue